// extracted by mini-css-extract-plugin
export default {"heading":"DashboardError_heading__7fgSs","forwardButton":"DashboardError_forwardButton__lz-1o"};